import { createContext } from 'react';

import { TreeMapCustomTooltipConfig } from '../types/treemap-chart.config.js';

export const DEFAULT_CUSTOM_TOOLTIP_CONFIG: TreeMapCustomTooltipConfig = {
  hidden: false,
};

export const TreeMapCustomTooltipContext =
  createContext<TreeMapCustomTooltipConfig>(DEFAULT_CUSTOM_TOOLTIP_CONFIG);
